/* eslint-disable no-unused-expressions */
import * as React from 'react';
import { Button } from '@cian/ui-kit/button';

import { TUser } from '../../api/getUser';
import { EEntityType, IFiltersState } from '../../types/filters';
import { getSearchUrl } from '../../utils/filters';
import { EDeviceType } from '../../types/device';
import { trackSearchOffersButtonClick, trackSignInButtonClick } from './tracking';

import * as styles from './ResultsEmpty.css';

export interface IResultsEmptyStoreProps {
  user: TUser;
  filters: IFiltersState;
  favoriteEntitiesLength: number;
  deviceType: EDeviceType;
}

export type TResultsEmptyProps = IResultsEmptyStoreProps;

// TODO: https://cianru.atlassian.net/browse/CD-42573
export class ResultsEmpty extends React.Component<TResultsEmptyProps> {
  public render() {
    const {
      user,
      filters: { favoriteEntityType },
      favoriteEntitiesLength,
      deviceType,
    } = this.props;

    if (favoriteEntitiesLength) {
      return null;
    }

    const isNewbuildingType = favoriteEntityType === EEntityType.Newbuilding;
    const backgroundImgClass = isNewbuildingType ? 'empty-newbuilding-background' : 'empty-background';

    return (
      <div className={styles['container']}>
        <div className={styles['wrapper']}>
          <div className={styles[backgroundImgClass]} />
          <div className={styles['title']}>
            {isNewbuildingType ? (
              <span>Здесь будут любимые жилые комплексы</span>
            ) : (
              <span>Добавляйте&nbsp;объявления в избранное</span>
            )}
          </div>
          <div className={styles['description']}>
            {isNewbuildingType
              ? 'Добавляйте понравившиеся ЖК в избранноеи будьте вкурсе новых предложений'
              : 'Отмечайте интересные объявления и следите за изменением цены'}
          </div>
          <Button
            size={deviceType === EDeviceType.Desktop ? 'XS' : 'M'}
            theme="fill_primary"
            onClick={this.handleButtonClick}
          >
            {user.isAuthenticated ? 'Искать объявления' : 'Войти'}
          </Button>
        </div>
      </div>
    );
  }

  private handleButtonClick = () => {
    const { user } = this.props;

    user.isAuthenticated ? trackSearchOffersButtonClick() : trackSignInButtonClick();
    user.isAuthenticated ? this.assignSearchUrl() : this.showLoginPopup();
  };

  private assignSearchUrl = () => {
    const { filters } = this.props;
    window.location.assign(getSearchUrl(filters));
  };

  private showLoginPopup = () => {
    if (window.hasOwnProperty('waitForLoginPopup')) {
      window.waitForLoginPopup();
    }
  };
}
